export async function getUserData() {
    try {
        let response = await fetch("/user-data", { credentials: "include" })
        let data = await response.json()
        return (data.user ? data.user : false);
    } catch (err) {
        console.log(err)
        return false;
    }
}